import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export const remonteePagesSlider = () => {
    const container = document.querySelector('[js-remontee-pages-slider]');

    if (container) {
        const breakpoint = window.matchMedia('(min-width: 1280px)');

        let slider;
        let slides;

        const inner = container.querySelector('.e-con-inner');

        if ( inner ) {
            slides = inner.querySelectorAll('.card-bubble')
        }

        const enableSlider = () => {
            if (!container.classList.contains('swiper-container')) {
                container.classList.add('swiper-container');
            }

            if (inner) {
                if (!inner.classList.contains('swiper-wrapper')) {
                    inner.classList.add('swiper-wrapper');
                }

                if (slides.length > 0) {
                    slides.forEach(function (element) {
                        if (!element.classList.contains('swiper-slide')) {
                            element.classList.add('swiper-slide');
                        }
                    });
                }
            }

            const pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            container.appendChild(pagination);

            slider = new Swiper(container, {
                modules: [ Pagination ],
                speed: 500,
                effect: 'slide',
                slidesPerView: 1.2,
                spaceBetween: 16,
                grabCursor: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    600: {
                        slidesPerView: 2.2,
                        spaceBetween: 24
                    },
                    1280: {
                        slidesPerView: 3.2,
                        spaceBetween: 24
                    },
                },
            });
        };

        const disableSlider = () => {
            if (container.classList.contains('swiper-container')) {
                container.classList.remove('swiper-container');

                const pagination =  container.querySelector('.swiper-pagination');

                if (pagination) {
                    pagination.remove();
                }

                if (inner && inner.classList.contains('swiper-wrapper')) {
                    inner.classList.remove('swiper-wrapper');
                }

                if (slides && slides.length > 0) {
                    slides.forEach(function (element) {
                        if (element.classList.contains('swiper-slide')) {
                            element.classList.remove('swiper-slide');
                        }
                    });
                }
            }

            if (slider) {
                slider.destroy(true, true);
                slider = undefined;
            }
        };

        const breakpointChecker = () => {
            if (slides.length < 5) {
                if (breakpoint.matches) {
                    disableSlider();
                } else {
                    enableSlider();
                }
            } else {
                enableSlider();
            }
        };

        breakpoint.addEventListener('change', breakpointChecker);
        breakpointChecker();
    }
};
